import { render, staticRenderFns } from "./ChatBoard.vue?vue&type=template&id=79bab365&scoped=true"
import script from "./ChatBoard.vue?vue&type=script&lang=js"
export * from "./ChatBoard.vue?vue&type=script&lang=js"
import style0 from "./ChatBoard.vue?vue&type=style&index=0&id=79bab365&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bab365",
  null
  
)

export default component.exports